export default "__VITE_ASSET__CqbyeFAH__"